import React from 'react';

export const styles: Record<string, React.CSSProperties> = {
  containerMobile: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    maxWidth: '430px',
    width: '100%',
    margin: '0 auto',
    position: 'relative',
    overflowX: 'hidden',
  },
  containerTablet: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    position: 'relative',
  },
  containerDesktop: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    position: 'relative',
  },
  contentMobile: {
    flex: 1,
    overflow: 'auto',
    paddingTop: '100px',
    paddingBottom: '110px',
  },
  contentDesktop: {
    flex: 1,
    overflow: 'auto',
    paddingTop: '100px',
    paddingLeft: '100px',
    paddingRight: '40px',
    paddingBottom: '40px',
  },
  innerMobile: {
    width: '100%',
  },
  innerTablet: {
    maxWidth: '720px',
    margin: '0 auto',
    width: '100%',
    padding: '0 24px',
  },
  innerDesktop: {
    maxWidth: '1200px',
    margin: '0 auto',
    width: '100%',
  },
};
